import moment from "moment";

export default () => {
  const formatDate = (value) => moment(value).format("YYYY-MM-DD");
  return {
    formatDate,
  };
};
